var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { ConfigError } from "../util/Errors.js";
import Util from "../util/Util.js";
import config from "../config/config.json.js";
function getAuthClientInstance(OktaAuth, options = {}) {
  let {
    authClient,
    authParams
  } = options;
  if (!authClient) {
    const {
      issuer,
      clientId,
      redirectUri,
      state,
      scopes,
      flow,
      codeChallenge,
      codeChallengeMethod,
      recoveryToken
    } = options;
    authParams = __spreadValues({
      issuer,
      clientId,
      redirectUri,
      state,
      scopes,
      flow,
      codeChallenge,
      codeChallengeMethod,
      transformErrorXHR: Util.transformErrorXHR,
      recoveryToken
    }, authParams);
    if (!authParams.issuer) {
      authParams.issuer = options.baseUrl + "/oauth2/default";
    }
    authClient = new OktaAuth(authParams);
  }
  if (!authClient._oktaUserAgent) {
    throw new ConfigError("The passed in authClient should be version 5.4.0 or above.");
  } else {
    authClient._oktaUserAgent.addEnvironment(`okta-signin-widget-${config.version}`);
  }
  return authClient;
}
export { getAuthClientInstance as default };
